













import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    pageData
} from "../store/pageData";

import {
    TweenLite
} from "gsap";
import Homeslider from '../components/Homeslider.vue';
import RichText from '../components/RichText.vue';
import HomePresenceCard from '../components/HomePresenceCard.vue';
import HomeTimeline from '../components/HomeTimeline.vue';
import QueryCard from '../components/QueryCard.vue';
import HomeNewseslider from '../components/HomeNewseslider.vue';
@Component({
    name: "HomePage",
    components: {
      Homeslider,
      title_sub_text_call_to_action: RichText,
      image_text_call_to_action: HomePresenceCard,
      time_line: HomeTimeline,
      title_call_to_action: QueryCard,
      home_news_slider: HomeNewseslider

    }
})
export default class HomePage extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public HOST: string = HOST;
    public pageLoaded: boolean = false;
}
